module.exports = __webpack_public_path__ + "media/images/bb-025d936c30f8ef4995560394c9b632d2.svg";